export enum OfferRequestActionEnum {
  PACKAGING_PROVIDE = "packaging-provide",
  PACKAGING_DECLINE = "packaging-decline",
  PHOTO_PROVIDE = "photo-provide",
  PHOTO_DECLINE = "photo-decline",
  HOLD_APPROVE = "hold-approve",
  HOLD_DECLINE = "hold-decline",
  OFFER_REQUEST_STATUS_APPROVE = "offer-request-status-approve",
  OFFER_REQUEST_STATUS_DECLINE = "offer-request-status-decline",
  QUANTITY_PROVIDE = "quantity-provide",
  QUANTITY_DECLINE = "quantity-decline",
  ORDER_PLACE = "order-place",
}
